// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";
import {changeOwed} from "../../WorkIssuanceOwed/owedSlice";
import EmojiFlagsIcon from "@mui/icons-material/EmojiFlags";
import PanToolIcon from "@mui/icons-material/PanTool";
import {changeWorkIssuance} from "../../workIssuanceSlice";


// main function
export default function HoldOwed({ onMenuClose, rowCdpStatus, showOwed, showExpense }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************

    const handleHold = () => {
        // dispatchData(changeOwed({holdState: true, owedNewStatus: 'Held'}));
        dispatchData(changeWorkIssuance({newStatus:  '2041', updateCdpStatus: true}));
        onMenuClose();
    };


    return (

        <Box>
            {(
                    rowCdpStatus !== "2039" ||  rowCdpStatus !== "2351" ||  rowCdpStatus !== "2041"
                ) && showOwed === true &&
                <MenuItem onClick={handleHold}>
                    <ListItemIcon>
                        <PanToolIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Hold</ListItemText>
                </MenuItem>
            }
        </Box>

    )

}
